import React from 'react';
import { IconButton } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// Presentational only — this admin panel has no real per-admin notification
// inbox yet (the existing `GETNotifications` service actually reads the
// promotions list, not notifications), so this deliberately shows no
// fabricated unread count.
export const NotificationBell: React.FC = () => (
  <IconButton
    size="small"
    sx={{
      width: 36,
      height: 36,
      bgcolor: '#181818',
      border: '1px solid #2c2c2c',
      color: '#e2e8f0',
      '&:hover': { bgcolor: '#232323' },
    }}
  >
    <NotificationsNoneIcon fontSize="small" />
  </IconButton>
);
